export const RESET_MATRIX = "CREATE_NEW_MATRIX";
export const CHANGE_VALUE = "CHANGE_VALUE";
export const CHANGE_ALGORITHM = "CHANGE_ALGORITHM";
export const SET_MATRIX = "SET_MATRIX";
export const ERASE_TOGGLE = "ERASE_TOGGLE";
export const MOUSE_UP_DOWN = "MOUSE_UP_DOWN";
export const START_MOVE = "START_MOVE";
export const END_MOVE = "END_MOVE";
export const CHANGE_START = "CHANGE_START";
export const CHANGE_END = "CHANGE_END";
export const CHANGE_WEIGHT = "CHANGE_WEIGHT";
export const CHANGE_WEIGHT_BUTTON = "CHANGE_WEIGHT_BUTTON";
export const RESET_WEIGHT_BUTTON = "RESET_WEIGHT_BUTTON";
export const CHANGE_TYPE = "CHANGE_TYPE";
export const CHANGE_DONE = "CHANGE_DONE";
export const MODAL_CHANGE = "MODAL_CHANGE";
export const CHANGE_STATUS = "CHANGE_STATUS";
export const TUTORIAL_DONE = "TUTORIAL_DONE";
